import { UtilitiesService } from '../../../../ng2/shared/services/utilities/utilities.service';

export default angular.module('nv.shared.services.utils', ['ngMaterial']).service('UtilitiesService', UtilitiesService)
  .name;
